import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AbstractTranslatableAlertService, AbstractAlertButtonColor, AuthSelector } from "@obg/ngx.core";
import { Observable } from "rxjs";
import { filter, map, take, tap } from "rxjs/operators";

import { NetLossLimitConfirmationStatus } from "../betting-limit/betting-limit.model";
import { updateNetLossLimitConfirmation } from "../betting-limit/netloss-limit-confirmation/netloss-limit-confirmation.action";

const NETLOSS_LIMIT_ALERT_ID = "NETLOSS_LIMIT_ALERT_ID";

@Injectable({
	providedIn: "root",
})
export class NetlossLimitPromptService {
	constructor(
		private store: Store,
		private alertService: AbstractTranslatableAlertService
	) {}

	initialize$(): Observable<void> {
		return this.store.select(AuthSelector.isAuthenticated).pipe(
			filter((isAuthenticated) => isAuthenticated),
			take(1),
			tap(() =>
				this.alertService.open(
					{
						id: NETLOSS_LIMIT_ALERT_ID,
						testId: NETLOSS_LIMIT_ALERT_ID,
						title: "netloss-limit.confirmation-prompt-title",
						message: "netloss-limit.confirmation-prompt-message",
						buttons: [
							{
								text: "netloss-limit.confirmation-prompt-button-confirm",
								handler: () =>
									this.store.dispatch(
										updateNetLossLimitConfirmation({
											payload: { status: NetLossLimitConfirmationStatus.Active },
										})
									),
							},
							{
								color: AbstractAlertButtonColor.Primary,
								text: "netloss-limit.confirmation-prompt-button-cancel",
								handler: () =>
									this.store.dispatch(
										updateNetLossLimitConfirmation({
											payload: { status: NetLossLimitConfirmationStatus.Cancelled },
										})
									),
							},
						],
						prefixJurisdiction: true,
						mustBeInteracted: true,
						hideClose: true,
						dialogConfig: {
							disableClose: true,
						},
					},
					[]
				)
			),
			map(() => undefined)
		);
	}
}
